import { JSX, useEffect, useRef, useState } from 'react'
import styles from './Navbar.module.css'
import { Link, Location, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import { fetchNavHoverData, HoverItem, NavHoverData } from '../../utils/Navbar/data';
import IconComponent from '../IconComponent/IconComponent';
import { MdClose } from 'react-icons/md';
import { HiOutlineMenuAlt4, HiOutlineX } from "react-icons/hi";
import { FaArrowUp } from 'react-icons/fa6';
import Dropdown from './Dropdown/Dropdown';
import { IoIosArrowUp, IoMdArrowBack } from "react-icons/io";
import axios from 'axios';
import DropdownDB from './DropdownDB/DropdownDB';
import { ServicesType } from '../../utils/Types/ServicesTypes';

export type NavbarProps = {
    location: Location<any>;
    services: ServicesType[];
    setServices: React.Dispatch<React.SetStateAction<ServicesType[]>>;
    setCurrentService: React.Dispatch<React.SetStateAction<number | null>>;
    setFilterProduct: React.Dispatch<React.SetStateAction<number | null>>;
    filterProduct: number | null;
    navBackground: boolean;
}

export type Categories = {
    ID: number;
    Name: string;
    Image: string;
}

export type Products = {
    ID: number;
    SubcategoryID: number;
    Name: string;
    MainImage: string;
    ImageList: Text;
    mostSold: number;
}

export type CategoriesTopImages = {
    ID: number;
    SubcategoryID: number;
    MainImage: string;
    Name: string;
}

export type SubCategories = {
    ID: number;
    CategoryID: number;
    Name: string;
}

export type Brands = {
    ID: number;
    CategoryID: number;
    name: string;
    Image: string;
    WebsiteLink: string;
}

const Navbar = (props: NavbarProps) => {

    const [navHoverData, setNavHoverData] = useState<NavHoverData | null>(null);
    const [hasBackground, setHasBackground] = useState(false);
    const [currentLink, setCurrentLink] = useState("");
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [hoveredNavLink, setHoveredNavLink] = useState<string | null>(null);
    const [hoveredNavLinkImg, setHoveredNavLinkImg] = useState<string | null>(null);
    const [hoveredNavLinkText, setHoveredNavLinkText] = useState<JSX.Element | null>(null);
    const [currentOpenItem, setCurrentOpenItem] = useState<string | null>("produtos");
    const [currentItem, setCurrentItem] = useState(1);
    const [currentHovered, setCurrentHovered] = useState(0);
    const [openMenu, setOpenMenu] = useState(false);
    const itemsRef = useRef<HTMLDivElement>(null);
    const contentLinksRef = useRef<HTMLDivElement>(null);
    const contentLinks2Ref = useRef<HTMLDivElement>(null);
    const hoverContainerRef = useRef<HTMLDivElement>(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);
    const [dropdownMenu, setDropDownMenu] = useState<string | null>(null);
    const navigate = useNavigate();
    const [showImages, setShowImages] = useState(false);

    const [currentCategory, setCurrentCategory] = useState<null | number>(null);
    const [categories, setCategories] = useState<Categories[]>([]);
    const [subCategories, setSubcategories] = useState<SubCategories[]>([]);
    const [brands, setBrands] = useState<Brands[]>([]);
    const [topProducts, setTopProducts] = useState<CategoriesTopImages[]>([]);
    const hideTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

    const handleFilterProducts = (id: number) => {
        if (!id) return;
        props.setFilterProduct(id);
        setOpenMenu(false);
        navigate("/produtos");
    }

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const [categories, service] = await Promise.all([
                    axios.get('https://sazuli.pt/api/categories'),
                    axios.get('https://sazuli.pt/api/services'),
                ]);
                setCurrentItem(categories.data[0].ID);
                setCategories(categories.data);
                props.setServices(service.data);

            } catch (err) {
                console.log(err);
            }
        }
        fetchAll();
    }, []);

    useEffect(() => {
        const loadData = async () => {
            const data = await fetchNavHoverData();
            setNavHoverData(data);
        };
        loadData();
    }, []);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const [products, subs, brands] = await Promise.all([
                    axios.get("https://sazuli.pt/api/products/mostsold2", { params: { categoryId: currentItem } }),
                    axios.get("https://sazuli.pt/api/subcategories", { params: { categoryId: currentItem } }),
                    axios.get("https://sazuli.pt/api/brands", { params: { categoryId: currentItem } })
                ]);
                setTopProducts(products.data);
                setSubcategories(subs.data);
                setBrands(brands.data);
            } catch (err) {
                console.error("Data fetch error:", err);
            }
        };
        fetchAll();
    }, [currentItem, currentOpenItem]);


    const handleDropdown = (type: string | null) => {
        if (type === dropdownMenu || type === null) {
            setDropDownMenu(null);
        } else {
            setDropDownMenu(type);
        }
    }

    const handleCurrentLink = () => {
        const current = window.location.pathname.split("/")[1] || 0;
        const validLinks = ["produtos", "servicos", "sazuli", "parceiros"];

        if (validLinks.includes(current.toString())) {
            setCurrentLink(current.toString());
        } else {
            setCurrentLink("");
        }
    }

    const handleMouseLeave = () => {
        setCurrentHovered(0);
        hideTimeout.current = setTimeout(() => {
            if (!props.navBackground) {   // only reset if not forced background
                setHasBackground(false);
            }
            setHoveredNavLinkImg(null);
            setHoveredNavLinkText(null);
            setHoveredNavLink(null);
        }, 150);
    }

    const handleMouseEnter = (type?: string) => {
        if (hideTimeout.current) {
            clearTimeout(hideTimeout.current);
            hideTimeout.current = null;
        }

        if (type && hoveredNavLink !== type) {
            hideTimeout.current = setTimeout(() => {
                if (type === 'servicos') {
                    setHoveredNavLink(type);
                    setHoveredNavLinkImg('servicos.jpg');
                    setHoveredNavLinkText(
                        <span>
                            Estamos ao seu lado em <br />
                            cada etapa da <br />
                            transformação da sua casa
                        </span>
                    )
                }
                if (type === 'sazuli') {
                    setHoveredNavLink(type);
                    setHoveredNavLinkImg('NavbarSazuli.jpg');
                    setHoveredNavLinkText(
                        <span>
                            Do chão ao charme
                        </span>
                    )
                }
                if (type === 'parceiros') {
                    setHoveredNavLink(type);
                    setHoveredNavLinkImg('parceiros.jpg');
                    setHoveredNavLinkText(
                        <span>
                            Trabalhamos com marcas de<br />
                            referência para garantir<br />
                            qualidade em cada detalhe
                        </span>
                    );
                }

                setCurrentHovered(0);
            }, 300);
        }

        setHasBackground(true);
    };

    const handleNavigateNavHover = (item: HoverItem) => {
        if (item.navigate === "servicos") {
            props.setCurrentService(item.id)
            setHoveredNavLink(null);
            setHoveredNavLinkImg(null);
            setHoveredNavLinkText(null);
            setCurrentHovered(1);
        }
        navigate(item.navigate)
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1200);
            setCurrentHovered(0);
            setHoveredNavLink(null);
            setHoveredNavLinkImg(null);
            setHoveredNavLinkText(null);
            setOpenMenu(false);
            setCurrentCategory(null);
            setDropDownMenu(null);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const el1 = contentLinksRef.current;
        const el2 = contentLinks2Ref.current;

        if (!el1 || !el2) return;

        const observer = new ResizeObserver(() => {
            const width = el1.offsetWidth;
            el2.style.minWidth = `${width}px`;
        });

        observer.observe(el1);

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        setCurrentHovered(0);
        setHoveredNavLink(null);
        setHoveredNavLinkImg(null);
        setHoveredNavLinkText(null);
        setCurrentCategory(null);
        setDropDownMenu(null);

        if (openMenu) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [openMenu])

    useEffect(() => {
        setOpenMenu(false);
        setCurrentHovered(0)
        setHoveredNavLink(null);
        setHoveredNavLinkImg(null);
        setHoveredNavLinkText(null);
        setCurrentCategory(null);
        setDropDownMenu(null);
        setHasBackground(props.navBackground);
        handleCurrentLink()
    }, [props.location.pathname, props.navBackground]);

    useEffect(() => {
        const onScroll = () => {
            const y = window.scrollY;

            if (openMenu === false) {
                if (y > lastScrollY && y > 64) {
                    setIsVisible(false);
                    setCurrentHovered(0)
                    setHoveredNavLink(null);
                    setHoveredNavLinkImg(null);
                    setHoveredNavLinkText(null);
                } else {
                    setIsVisible(true);
                    setHasBackground(true);
                }
                setLastScrollY(y);
                if (y === 0) {
                    setHasBackground(false);
                }
            }

        };

        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [lastScrollY, openMenu]);

    useEffect(() => {
        if (openMenu) {
            const timer = setTimeout(() => {
                setShowImages(true);
            }, 300); // wait for menu animation

            return () => clearTimeout(timer);
        } else {
            setShowImages(false);
        }
    }, [openMenu]);

    return (
        <div
            className={`${styles.container} ${hasBackground && styles.hasBackground} ${!isVisible ? styles.hidden : ''} ${openMenu ? styles.grow : styles.shrink}`}
            style={{
                height: openMenu ? isMobile ? '100dvh' : 'calc(100dvh - 12rem)' : hoveredNavLink ? 'auto' : 'auto',
                backgroundColor: hasBackground ? "#FFFFFF" : "transparent",
                color: hasBackground ? "#FFFFFF" : "#000000",
                borderRadius: hoveredNavLink ? "15px 15px 0 0" : "15px",
                boxShadow: hasBackground ? "0 2px 4px rgba(0, 0, 0, 0.1)" : "none",
            }}
        >
            <div
                className={`${styles.items}`}
                ref={itemsRef}
            >
                {isMobile && (
                    <div className={styles.item}>
                        <div className={styles.menuIcon}>
                            <div className={`${styles.iconMenu} ${!openMenu ? styles.activeMenu2 : ''}`} onClick={() => setOpenMenu(!openMenu)}>
                                <IconComponent icon={HiOutlineMenuAlt4} size={20} />
                            </div>
                        </div>
                    </div>
                )}
                <div
                    className={`${styles.item} ${styles.nav_links} ${props.navBackground ? styles.lettersBackground : ''}`}
                >
                    {openMenu ? (
                        <span className={`${styles.active} ${styles.nav_link_btn}`} onClick={() => setOpenMenu(false)}>
                            <IconComponent icon={MdClose} size={20} />
                        </span>
                    ) : (
                        <>
                            <span
                                className={currentLink === "produtos" ? styles.active : ''}
                                onClick={() => { setOpenMenu(true); setCurrentOpenItem("produtos") }}
                            >
                                Produtos
                            </span>
                            <Link
                                to={"/servicos"}
                                className={currentLink === "servicos" ? styles.active : ''}
                                onMouseEnter={() => { handleMouseEnter("servicos"); }}
                                onMouseLeave={() => handleMouseLeave()}
                            >
                                Serviços
                            </Link>
                            <Link
                                to={"/sazuli"}
                                className={currentLink === "sazuli" ? styles.active : ''}
                                onMouseEnter={() => { handleMouseEnter("sazuli"); }}
                                onMouseLeave={() => handleMouseLeave()}
                            >
                                Sazuli
                            </Link>
                            <Link
                                to={"/parceiros"}
                                className={currentLink === "parceiros" ? styles.active : ''}
                                onMouseEnter={() => { handleMouseEnter("parceiros"); }}
                                onMouseLeave={() => handleMouseLeave()}
                            >
                                Parceiros
                            </Link>
                        </>
                    )}
                </div>
                <div className={`${styles.item} ${styles.logo} ${openMenu && isMobile && styles.logoLeft}`}>
                    {currentCategory ? (
                        <div className={styles.categoryBack} onClick={() => setCurrentCategory(null)}>
                            <IconComponent icon={IoMdArrowBack} size={20} />
                        </div>
                    ) : (
                        <img src={'https://sazuli.pt/uploads/logo.png'} alt="Sazuli" onClick={() => { navigate("/"); }} />

                    )}
                </div>
                {isMobile && (
                    <div className={styles.item}>
                        <div className={styles.menuIcon}>
                            <div className={`${styles.iconMenu} ${styles.closeMenu} ${openMenu ? styles.activeMenu : ''}`} onClick={() => setOpenMenu(!openMenu)}>
                                <IconComponent icon={HiOutlineX} size={20} />
                            </div>
                        </div>
                    </div>
                )}
                <div className={`${styles.item} ${styles.nav_buttons}`}>
                    {!openMenu && (
                        <Link to={"/contactos"} className={styles.activeBtn}>Contactos</Link>
                    )}
                </div>

                {hoveredNavLink && navHoverData && navHoverData[hoveredNavLink] && (
                    <div
                        className={styles.hoverPanel}
                        onMouseEnter={() => handleMouseEnter()}
                        onMouseLeave={() => handleMouseLeave()}
                    >
                        <div className={styles.hoverContainer}>
                            <div className={styles.hoverLinks} ref={hoverContainerRef}>
                                <div className={styles.hoverLinksWrapper}>
                                    {navHoverData[hoveredNavLink].map((item: any, index: number) => (
                                        <span
                                            key={index}
                                            onMouseEnter={() => setCurrentHovered(index)}
                                            onClick={() => handleNavigateNavHover(item)}
                                        >
                                            {item.title}
                                        </span>
                                    ))}
                                </div>
                                <div className={styles.support}>
                                    <span onClick={() => navigate("/contactos")}>Suporte</span>
                                </div>
                            </div>
                            <div className={styles.hoverContent}>
                                <img
                                    src={
                                        hoveredNavLinkImg
                                            ? `https://sazuli.pt/uploads/${hoveredNavLinkImg}`
                                            : './assets/images/placeholder_image.png'
                                    }
                                    alt={hoveredNavLink || "Imagem não encontrada"}
                                    className={styles.hoverImageNavbar}
                                />
                                <div className={styles.hoverDescription}>{hoveredNavLinkText}</div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className={`${styles.content} ${openMenu ? styles.openMenu : styles.closeMenu}`}>
                {isMobile ? (
                    <div className={styles.mobileMenu}>
                        <div className={styles.linksMobile}>
                            <div className={styles.linksItem}>
                                <div className={`${styles.linksItemIcon} ${props.navBackground ? styles.lettersBackground : ''} ${dropdownMenu === "produtos" && styles.rotateIcon}`} onClick={() => handleDropdown("produtos")}>
                                    <span>Produtos</span>
                                    <IconComponent icon={IoIosArrowUp} size={15} />
                                </div>
                                <DropdownDB
                                    items={
                                        categories
                                    }
                                    isActive={dropdownMenu === "produtos"}
                                    setCurrentCategory={setCurrentCategory}
                                    setCurrentItem={setCurrentItem}
                                />
                            </div>
                            <div className={styles.linksItem} onClick={() => handleDropdown("servicos")}>
                                <div className={`${styles.linksItemIcon} ${props.navBackground ? styles.lettersBackground : ''} ${dropdownMenu === "servicos" && styles.rotateIcon}`}>
                                    <span>Serviços</span>
                                    <IconComponent icon={IoIosArrowUp} size={15} />
                                </div>
                                <Dropdown
                                    items={
                                        [
                                            ...props.services.map((item) => ({
                                                title: item.Title,
                                                navigate: "/servicos"
                                            })),
                                        ]
                                    }
                                    isActive={dropdownMenu === "servicos"}
                                />
                            </div>
                            <div className={`${styles.linksItem} ${props.navBackground ? styles.lettersBackground : ''}`} onClick={() => navigate("/sazuli")}>
                                <span>Sazuli</span>
                            </div>
                            <div className={`${styles.linksItem} ${props.navBackground ? styles.lettersBackground : ''}`} onClick={() => navigate("/parceiros")}>
                                <span>Parceiros</span>
                            </div>
                            <div className={`${styles.linksItem} ${props.navBackground ? styles.lettersBackground : ''}`} onClick={() => navigate("/contactos")}>
                                <span>Contactos</span>
                            </div>
                        </div>
                        <div className={styles.socialMediaMobile}>
                            <div className={styles.socialMediaMobileWrapper}>
                                <a href="https://www.instagram.com/sazuli_ceramicas" target="_blank" rel="noopener noreferrer">
                                    Instagram
                                </a>
                                <IconComponent icon={FaArrowUp} size={10} />
                            </div>
                            <div className={styles.socialMediaMobileWrapper}>
                                <a href="https://www.facebook.com/sazuli.lda" target="_blank" rel="noopener noreferrer">Facebook</a>
                                <IconComponent icon={FaArrowUp} size={10} />
                            </div>
                            <div className={styles.socialMediaMobileWrapper}>
                                <a href="https://www.linkedin.com/in/sazuli-lda-a0520b312" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                                <IconComponent icon={FaArrowUp} size={10} />
                            </div>
                        </div>

                        <div className={`${styles.categoriesItems} ${currentCategory ? styles.openedCategory : styles.closedCategory}`}>
                            <div className={styles.contentImages}>
                                <div className={styles.itemsImages}>
                                    {topProducts[0] && (
                                        <div className={styles.itemImages} onClick={() => handleFilterProducts(topProducts[0]?.SubcategoryID)}>
                                            <img src={topProducts[0].MainImage ?
                                                `https://sazuli.pt/uploads/${topProducts[0].MainImage}`
                                                : './assets/images/placeholder_image2.png'
                                            } alt={topProducts[0].Name} />
                                            <span className={styles.itemName}>{topProducts[0] && topProducts[0].Name ? topProducts[0].Name : ''}</span>
                                        </div>
                                    )}
                                </div>
                                <div className={styles.itemsImages}>
                                    {topProducts[1] && (
                                        <div className={styles.itemImages} onClick={() => handleFilterProducts(topProducts[1]?.SubcategoryID)}>
                                            <img src={topProducts[1].MainImage ?
                                                `https://sazuli.pt/uploads/${topProducts[1].MainImage}`
                                                : './assets/images/placeholder_image2.png'
                                            } alt={topProducts[1].Name} />
                                            <span className={styles.itemName}>{topProducts[1] && topProducts[1].Name ? topProducts[1].Name : ''}</span>
                                        </div>
                                    )}
                                    {topProducts[2] && (
                                        <div className={styles.itemImages} onClick={() => handleFilterProducts(topProducts[2]?.SubcategoryID)}>
                                            <img src={`https://sazuli.pt/uploads/${topProducts[2].MainImage}`
                                            } alt={topProducts[2].Name} />
                                            <span className={styles.itemName}>{topProducts[2] && topProducts[2].Name ? topProducts[2].Name : ''}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={styles.contentLinks} ref={contentLinksRef}>
                                <div className={styles.contentLinks2Wrapper}>
                                    <div className={styles.links2}>
                                        <div className={styles.subtitle}>
                                            <span>Subcategorias</span>
                                        </div>
                                        <div className={styles.scrollDown}>
                                            {currentOpenItem && subCategories.map((item, index) => (
                                                <span className={styles.sub_brand_link} key={index} onClick={() => handleFilterProducts(item.ID)}>{item.Name}</span>
                                            ))}
                                        </div>
                                    </div>
                                    <div className={styles.links2}>
                                        <div className={styles.subtitle}>
                                            <span>Parceiros</span>
                                        </div>
                                        <div className={styles.scrollDown}>
                                            {currentOpenItem && brands.map((item, index) => (
                                                <span className={styles.sub_brand_link} key={index} onClick={() => {
                                                    setOpenMenu(false);
                                                    navigate(`/parceiros?brandName=${item.CategoryID}`);
                                                }}>{item.name}</span>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className={styles.contentLinks} ref={contentLinksRef}>
                            <div className={styles.contentLinksWrapper}>
                                {currentOpenItem && categories && categories.map((item: any, index) => (
                                    <span
                                        key={index}
                                        className={currentItem === item.ID ? styles.current : ''}
                                        onClick={() => setCurrentItem(item.ID)}
                                    >{item.Name}</span>
                                ))}
                            </div>
                            <div className={styles.support}>
                                <span onClick={() => navigate("/contactos")}>Suporte</span>
                            </div>
                        </div>
                        {currentOpenItem && topProducts && (
                            <>
                                <div className={styles.contentImages}>
                                    <div className={styles.itemsImages}>
                                        {topProducts[0] && (
                                            <div className={styles.itemImages} onClick={() => handleFilterProducts(topProducts[0]?.SubcategoryID)}>
                                                <img src={showImages && topProducts[0] ?
                                                    `https://sazuli.pt/uploads/${topProducts[0].MainImage}`
                                                    : './assets/images/placeholder_image2.png'
                                                } alt={"Produtos"} />
                                                <span className={styles.itemName}>{topProducts[0] && topProducts[0].Name ? topProducts[0].Name : ''}</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className={styles.itemsImages}>
                                        {topProducts[1] && (
                                            <div className={styles.itemImages} onClick={() => handleFilterProducts(topProducts[1]?.SubcategoryID)}>
                                                <img src={showImages && topProducts[1] ?
                                                    `https://sazuli.pt/uploads/${topProducts[1].MainImage}`
                                                    : './assets/images/placeholder_image2.png'
                                                } alt={"Produtos"} />
                                                <span className={styles.itemName}>{topProducts[1] && topProducts[1].Name ? topProducts[1].Name : ''}</span>
                                            </div>
                                        )}
                                        {topProducts[2] && (
                                            <div className={styles.itemImages} onClick={() => handleFilterProducts(topProducts[2]?.SubcategoryID)}>
                                                <img src={topProducts[2] ?
                                                    `https://sazuli.pt/uploads/${topProducts[2].MainImage}`
                                                    : './assets/images/placeholder_image2.png'
                                                } alt={topProducts[2] && topProducts[2].Name ? topProducts[2].Name : ''} />
                                                <span className={styles.itemName}>{topProducts[2] && topProducts[2].Name ? topProducts[2].Name : ''}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className={styles.contentLinks2} ref={contentLinks2Ref}>
                                    <div className={styles.contentLinks2Wrapper}>
                                        <div className={styles.links2}>
                                            <div className={styles.subtitle}>
                                                <span>Subcategorias</span>
                                            </div>
                                            <div className={styles.scrollDown}>
                                                {currentOpenItem && subCategories.map((item, index) => (
                                                    <span className={styles.sub_brand_link} key={index} onClick={() => handleFilterProducts(item.ID)}>{item.Name}</span>
                                                ))}
                                            </div>
                                        </div>
                                        <div className={styles.links2}>
                                            <div className={styles.subtitle}>
                                                <span>Parceiros</span>
                                            </div>
                                            <div className={styles.scrollDown}>
                                                {currentOpenItem && brands.map((item, index) => (
                                                    <span className={styles.sub_brand_link} key={index} onClick={() => {
                                                        setOpenMenu(false);
                                                        navigate(`/parceiros?brandName=${item.CategoryID}`);
                                                    }}>{item.name}</span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

export default Navbar
